import { useMemo } from 'react';
import { CountBadge } from 'assets/js/pages/contacts/data-hygiene/CountBadge';
import * as SubNav from 'components/sub-nav';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useDataHygieneMetrics } from 'customHooks/useDataHygieneMetrics';

const ContactsSubNavTabs = () => {
    const { accountId, hasGivebutterPlusAccess } = useCurrentAccount();
    const { data: metrics } = useDataHygieneMetrics();

    const dataHygieneCount = useMemo(() => {
        if (hasGivebutterPlusAccess) {
            return metrics.data_hygiene.total + metrics.data_hygiene.duplicates.total;
        }
        return metrics.data_hygiene.duplicates.total;
    }, [
        hasGivebutterPlusAccess,
        metrics.data_hygiene.duplicates.total,
        metrics.data_hygiene.total,
    ]);

    return (
        <SubNav.Tabs>
            <SubNav.TabItem to={`/accounts/${accountId}/contacts`}>
                <span className="flex flex-wrap items-center justify-start gap-2">
                    <span>Individuals</span>
                    <CountBadge
                        count={metrics.individuals.total}
                        className={
                            'group-[.active]/navlink:bg-blue-50 group-[.active]/navlink:text-blue-700'
                        }
                    />
                </span>
            </SubNav.TabItem>
            <SubNav.TabItem to={`/accounts/${accountId}/companies`}>
                <span className="flex flex-wrap items-center justify-start gap-2">
                    <span>Companies</span>
                    <CountBadge
                        count={metrics.companies?.total}
                        className={
                            'group-[.active]/navlink:bg-blue-50 group-[.active]/navlink:text-blue-700'
                        }
                    />
                </span>
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/data-hygiene`}
                data-intercom-target={IntercomProductTourTargets.ContactsDataHygieneSubnavTab}
                data-testid={TestIds.Contacts.DataHygiene}
            >
                <span className="flex flex-wrap items-center justify-start gap-2">
                    <span>Data Hygiene and Duplicates</span>
                    <CountBadge
                        count={dataHygieneCount}
                        className={
                            'group-[.active]/navlink:bg-blue-50 group-[.active]/navlink:text-blue-700'
                        }
                    />
                </span>
            </SubNav.TabItem>
        </SubNav.Tabs>
    );
};

export { ContactsSubNavTabs };
